export default __webpack_public_path__ + "static/media/section4.6748342d.jpg";